import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'smarttv',
	templateUrl: 'smarttv.component.html',
	styleUrls: ['./smarttv.component.css']

})

export class SmarttvComponent implements OnInit {
	constructor() { }

	ngOnInit() { }
}